<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_accounts.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name" (ttModelChange)="onChanged($event, 'businessco_no')"></tt-select>
            <tt-select ttRememberId="w_accounts.language_id" ttLabel="language" [(ttModel)]="setting.language_id" [ttData]="selectListLanguages" ttDataId="item_id" ttDataName="item_name" (ttModelChange)="onChanged($event, 'language_id')"></tt-select>
            <tt-checkbox ttRememberId="w_accounts.show_not_active" ttLabel="show_not_active" [(ttModel)]="setting.show_not_active" (ttModelChange)="onChanged($event, 'show_not_active')"></tt-checkbox>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-button-goto [ttText]="'account_new'" (ttClick)="goToFunc('account')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
            <tt-select class="col-xs-12 sp-0" tt-label="language" tt-model="vm.model.setting.language_id" tt-change="vm.onChanged($value, 'language_id')" tt-data="vm.model.selectListLanguages" tt-data-id="item_id" tt-data-name="item_name"></tt-select>
            <tt-checkbox class="col-xs-12 sp-0" tt-label="show_not_active" tt-model="vm.model.setting.show_not_active" tt-change="vm.onChanged($value, 'show_not_active')"></tt-checkbox>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-button class="col-xs-12 sp-0" tt-text="account_new" tt-click="vm.goToFunc('account')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
        </tt-card>
    </div>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
